// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3TV81","tab":"Tabs_tab__3b3jl","tabActive":"Tabs_tabActive__2SF0j"};